/**
 *  ・クラス名
 *    工事ドメインモデル
 *  ・概要
 *    工事ドメインモデルで使用可能な処理を記述
 *  ・更新履歴
 *    2021/01/27 新規作成 富本
 */
import BaseModel from '@/models/baseModel';

import ConstructionSubject from '@/models/data/constructionSubject';
import Customer from '@/models/data/customer';
import Department from '@/models/data/department';
import Material from '@/models/data/material';
import Staff from '@/models/data/staff';
import Supplier from '@/models/data/supplier';
import Subcontractor from '@/models/data/subcontractor';

/* eslint-disable @typescript-eslint/camelcase */
/**
 * マスタ・データレポートAPIコール時のpayload定義
 *
 * @param conditions 検索項目、検索値を指定
 * @param sort_fields ソート項目、昇順または降順を指定
 * @param per_page 1ページあたりの表示数 0で全件表示
 * @param page ページ数を指定
 * @param use_display_id display_idで検索するか
 */
export interface Payload {
  conditions?: {
    id: string;
    search_value: Array<string>;
  }[];
  sort_fields?: [
    {
      id: string;
      order: 'desc' | 'asc';
    }
  ];
  per_page?: number;
  page?: number;
  use_display_id?: boolean;
}

export default class ConstructionModel extends BaseModel {
  private constructionSubject = new ConstructionSubject();
  private customer = new Customer();
  private department = new Department();
  private material = new Material();
  private staff = new Staff();
  private supplier = new Supplier();
  private subcontractor = new Subcontractor();

  private masterData: { [k: string]: { [k: string]: Array<{ [k: string]: string }> } } = {};

  constructor() {
    super();
  }

  /**
   * 各種入力フォームで使用する各マスタ情報を取得
   * プロパティーに格納します
   * @param none
   * @returns void
   */
  public async getMasterData() {
    const mData: { [k: string]: { [k: string]: Array<{ [k: string]: string }> } } = {};
    // 工事科目マスタ
    mData['m_construction_subject'] = await this.constructionSubject.getFormatData();
    // 取引先マスタ
    mData['m_customer'] = await this.customer.getFormatData();
    // 仕入先マスタ
    mData['m_supplier'] = await this.supplier.getFormatData();
    // 部門マスタ
    mData['m_department'] = await this.department.getFormatData();
    // 素材マスタ
    mData['m_material'] = await this.material.getFormatData();
    // 担当者マスタ
    mData['m_staff'] = await this.staff.getFormatData();
    // 外注先マスタ
    mData['m_subcontractor'] = await this.subcontractor.getFormatData();
    this.masterData = mData;
  }

  /**
   * マスタ情報を取得します
   * @returns {array} - マスタ情報配列
   */
  public getMaster() {
    return this.masterData;
  }

  public getField(appId: string, dId: string) {
    return this.getFieldsData(appId, dId).then(data => data);
  }
}
